<template>
  <main class="pt-5">
    <section
      class="bg-cover bg-center py-20 px-0 object-fill text-white text-center rounded"
    >
      <TableApi />
    </section>
  </main>
</template>

<script>
import TableApi from "@/components/TableApi.vue";

export default {
  name: "Table",
  components: {
    TableApi,
  },
};
</script>

<style scoped>
section {
  background-image: url("../assets/Grupo 1.png");
}

.animate-ping-caxias {
  animation: ping 2s cubic-bezier(0, 0, 0.2, 1) infinite;
  margin: 0 auto;
}

@keyframes ping {
  75%,
  100% {
    transform: scale(1.2);
    opacity: 0;
  }
}

.border-white-f2 {
  border-color: #f2f2f2;
}
</style>
